import React from 'react';

/** Circular avatar with initial fallback (hosts, members, transcript speakers). */
export function Avatar({ name = '', src, size = 32, className = '', style, ...rest }) {
  return (
    <span
      className={`bjl-avatar ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42), ...style }}
      {...rest}
    >
      {src ? <img src={src} alt={name} /> : name.trim().charAt(0)}
    </span>
  );
}
